import { createContext } from 'react';
import { type Page } from '@/types/auth';

interface AppContextType {
  currentPage: Page;
  setCurrentPage: (page: Page) => void;
}

export const AppContext = createContext<AppContextType>({
  currentPage: 'tasks',
  setCurrentPage: () => {},
});
